//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getOpenId, getOpenId1, getOpenId2} from '@/api/login'
export default {
  name: 'Login',
  data () {
    return {
      showHint: '',
      showWarn: false,
      warn: '',
      phone: '',
      code: '',
      codeText: true,
      count: 300,
      timer: null,
      showuser: {display: 'none'},
      showpaw: {display: 'none'},
      // openId: 'oiUWk0rz4Yjc7xuBX50FHVGRBn6U'
      openId: '',
      showLoad: true,
      tokenLine: '',
      urltag: '',
      baseUrl: ''
    }
  },
  methods: {
    showUser: function () {
      let reg = /^1[3456789]\d{9}$/
      if (this.phone === '') {
        this.showHint = '请输入手机号'
      } else if (!(reg.test(this.phone))) {
        this.showHint = '手机格式错误'
      } else {
        this.showHint = ''
      }
    },
    showPass: function () {
      if (this.code === '') {
        this.showHint = '请输入验证码'
      } else {
        this.showHint = ''
      }
    },
    getCode () {
      let vm = this
      if (this.phone === '') {
        this.showHint = '请输入手机号'
      } else {
        this.$http.post(this.baseUrl + 'getauthcode', {name: this.phone, urltag: this.urltag}).then(res => {
          console.log(res)
          if (res.data.code === 200) {
            this.codeText = false
            this.timer = setInterval(() => {
              if (vm.count > 0 && vm.count <= 300) {
                vm.count--
              } else {
                vm.codeText = true
                clearInterval(vm.timer)
                vm.timer = null
              }
            }, 1000)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    login () {
      // location.href = 'https://mp.weixin.qq.com/mp/subscribemsg?action=get_confirm&appid=wxd4c4de465ee2a3df&scene=1000&template_id=Pju_Y6HKv-s2rVyRZT0HZcHIGatihits2r8LPxWiDik&redirect_url=' + encodeURI('http://anfangwx.aimtyiot.cn/') + '&reserved=test#wechat_redirect'
      if (this.phone === '') {
        this.showHint = '请输入手机号'
      } else if (this.code === '') {
        this.showHint = '请输入验证码'
      } else {
        console.log('code', this.code, 'name', this.phone, 'openid', this.openId, 'urltag', this.urltag)
        this.$http.post(this.baseUrl + 'auth', {code: this.code, name: this.phone, openid: this.openId, urltag: this.urltag}).then(res => {
          // console.log('success', res)
          if (res.data.code === 200) {
            this.$store.commit('set_token', res.data.data.token)
            // this.$store.commit('set_openid', res.data.data.token)
            this.$store.commit('set_user', this.phone)
            this.$store.commit('set_topc', res.data.data.mqtttopic)
            this.startSub(this, res.data.data.mqtttopic)
            if (this.$route.query.deviceid) {
              this.$router.push('/addDevice')
            } else {
              this.$router.push('/home')
            }
          } else {
            this.showWarn = true
            this.warn = res.data.msg
          }
        }).catch(err => {
          console.log('err', err)
        })
      }
    },
    //  获取code
    getwxCode () {
      // console.log(window.location.href)
      let url = window.location.host
      let vm = this
      // console.log(345, url)
      if (this.$route.query.code) {
        if (this.$store.getters.get_openid !== '') {
          if (this.$route.query.deviceid) {
            this.$router.push('/addDevice')
          } else {
            this.$router.push('/home')
          }
        } else {
          if (url === 'aimtycloud.anfangwx.aimtyiot.cn') { // 艾米云
            getOpenId1(this.$route.query.code).then(res => {
              // console.log(res)
              this.openId = res.OpenID
              this.$store.commit('set_openid', this.openId)
              this.checkId(res.OpenID)
            }).catch(error => {
              this.showLoad = false
              console.log(error)
            })
          } else if (url === 'anfangwxtest.aimtyiot.cn') { // 测试
            getOpenId2(this.$route.query.code).then(res => {
              // console.log(res)
              this.openId = res.OpenID
              this.$store.commit('set_openid', this.openId)
              this.checkId(res.OpenID)
            }).catch(error => {
              this.showLoad = false
              console.log(error)
            })
          } else { // 艾米
            getOpenId(this.$route.query.code).then(res => {
              // console.log(res)
              this.openId = res.OpenID
              this.$store.commit('set_openid', this.openId)
              this.checkId(res.OpenID)
            }).catch(error => {
              this.showLoad = false
              console.log(error)
            })
          }
        }
      } else if (this.$route.query.wxid && this.$route.query.alarmid) {
        vm.checkIdAlarm(this.$route.query.wxid, this.$route.query.alarmid)
      } else {
        if (vm.tokenLine !== '') {
          if (this.$route.query.deviceid) {
            this.$router.push('/addDevice')
          } else {
            this.$router.push('/home')
          }
        } else {
          vm.showLoad = false
        }
      }
    },
    // 检测alarm openid
    checkIdAlarm (id, alarmid) {
      // console.log('检测', this.urltag)
      this.$http.post(this.baseUrl + 'checkopenid', {openid: id, urltag: this.urltag}).then(res => {
        // console.log('检测', res)
        if (res.data.code === 200) {
          this.$store.commit('set_token', res.data.data.token)
          this.$store.commit('set_alarm_id', alarmid)
          this.$store.commit('set_alarm_handle', true)
          this.$store.commit('set_user', res.data.data.phone)
          this.$store.commit('set_topc', res.data.data.mqtttopic)
          this.$store.commit('set_openid', id)
          this.startSub(this, res.data.data.mqtttopic)
          this.$router.push('/Alarm')
        } else {
          this.showLoad = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 检测openid
    checkId (id) {
      this.$http.post(this.baseUrl + 'checkopenid', {openid: id, urltag: this.urltag}).then(res => {
        if (res.data.code === 200) {
          this.$store.commit('set_token', res.data.data.token)
          this.$store.commit('set_user', res.data.data.phone)
          this.$store.commit('set_topc', res.data.data.mqtttopic)
          this.$store.commit('set_openid', id)
          this.startSub(this, res.data.data.mqtttopic)
          if (this.$route.query.deviceid) {
            this.$router.push('/addDevice')
          } else {
            this.$router.push('/home')
          }
        } else {
          this.showLoad = false
        }
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    // this.closeSub()
    if (this.$route.query.deviceid) {
      this.$store.commit('set_deviceid', this.$route.query.deviceid)
    } else {
      this.$store.commit('set_deviceid', '')
    }
    console.log(789, this.$route.query)
    let host = window.location.host
    if (host === 'aimtycloud.anfangwx.aimtyiot.cn') {
      this.baseUrl = this.base
      this.urltag = 1
    } else if (host === 'anfangwxtest.aimtyiot.cn') {
      this.baseUrl = this.base
      this.urltag = 2
    } else {
      this.baseUrl = this.base
      this.urltag = 0
    }
    this.tokenLine = this.$store.getters.get_token
    this.getwxCode()
  }
}



// WEBPACK FOOTER //
// ./src/view/Login.vue